import { RegistrationItemCustomField } from './registration-item-custom-field.model';
import { RegistrationItemSponsor } from './registration-item-sponsor.model';
import { EventItemTaxItem } from '../../shared/items/event-item-tax-item.model';

export class RegistrationItem {
  public EventItemId: number;
  public Descr: string;
  public Quantity: number;
  public ExtendedPrice: number;
  public ItemAmountTotal: number;
  public DisplayPrice: number;
  public EventItemSignUpId: number;
  public AvailableCustomFields: Array<RegistrationItemCustomField>;
  public IsSponsorShip: boolean;
  public Sponsor: RegistrationItemSponsor;

  public Selected: boolean;

  public AttendeesForItem: number;
  public MaxItemsAvail: number;
  public Sold: number;
  public Remaining: number;
  public MembersOnly: boolean;
  public RestrictForAffiliations: boolean;
  public Expires: boolean;
  public StartDate: Date;
  public EndDate: Date;
  public ShowAsTeaserifRestricted: boolean;
  public TeaserMessage: string;
  public RestrictedMessage: string;
  public MemberPrice: number;
  public NonMemberPrice: number;
  public AllowRelateProfileMemberPrice: boolean;
  public DisplayOrder: number;
  public HasMemberPricing: boolean;
  public PaymentTypeId: number;

  public ItemNum: number;
  public Taxable: boolean;
  public TaxPercent: number;
  public TaxFlatAmount: number;
  public TaxItems: Array<EventItemTaxItem>;
  public CreateSeparateAttendee: boolean;

  public constructor() {
    this.EventItemId = 0;
    this.Descr = '';
    this.Quantity = 0;
    this.ExtendedPrice = 0;
    this.ItemAmountTotal = 0;
    this.DisplayPrice = 0;
    this.EventItemSignUpId = 0;
    this.AvailableCustomFields = new Array<RegistrationItemCustomField>();

    this.Selected = false;

    this.AttendeesForItem = 0;
    this.MaxItemsAvail = 0;
    this.Sold = 0;
    this.Remaining = 0;
    this.MembersOnly = false;
    this.RestrictForAffiliations = false;
    this.Expires = false;
    this.StartDate = new Date();
    this.EndDate = new Date();
    this.ShowAsTeaserifRestricted = false;
    this.TeaserMessage = '';
    this.RestrictedMessage = '';
    this.MemberPrice = 0;
    this.NonMemberPrice = 0;
    this.AllowRelateProfileMemberPrice = false;
    this.DisplayOrder = 0;
    this.HasMemberPricing = false;
    this.PaymentTypeId = 0;
    this.Sponsor = new RegistrationItemSponsor();
    this.IsSponsorShip = false;

    this.ItemNum = 0;
    this.Taxable = false;
    this.TaxPercent = 0;
    this.TaxFlatAmount = 0;

    this.TaxItems = new Array<EventItemTaxItem>();
  }
}
